import React from 'react';
import Modal from '../../Modals/Modal';
import PrimaryButtonV2 from '../../Buttons/PrimaryButtonV2';

import Spinner from '../../Spinner/Spinner';
import { useTranslation } from '../../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  handleCancel: () => void;
  isLoading: boolean;
  header: string;
  message: string;
  subMessage?: string;
};

const CancelDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  handleCancel,
  isLoading,
  header,
  message,
  subMessage,
}) => {
  const { translations } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={`${translations(header)}`}
      containerPadding={'20px 40px 60px 40px'}
      headerStyles={{
        position: 'relative',
        textAlign: 'center',
        paddingTop: '40px',
      }}
      closeButtonStyles={{
        position: 'absolute',
        top: 0,
        right: 0,
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginTop: 10 }}>{translations(message)}</div>
        {subMessage && <div style={{ marginTop: 10 }}>{translations(subMessage)}</div>}
        {isLoading && <Spinner />}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
        <PrimaryButtonV2
          text={translations('yes')}
          containerStyle={{ marginRight: 20 }}
          buttonStyle={{ height: 50, width: 180 }}
          onClick={() => handleCancel()}
          disabled={isLoading}
        />
        <PrimaryButtonV2
          text={translations('no')}
          invertedColors
          buttonStyle={{ height: 50, width: 180 }}
          onClick={() => onClose()}
          disabled={isLoading}
        />
      </div>
    </Modal>
  );
};

export { CancelDialog };
